import { render, staticRenderFns } from "./EditPartition.vue?vue&type=template&id=ab18acf6&"
import script from "./EditPartition.vue?vue&type=script&lang=js&"
export * from "./EditPartition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports